import React from 'react';
import styled from 'styled-components';
import SubTitle from '../../Components/Text/SubTitle';
import Diagram from '../../Components/Item/Diagram';
import ScrollAnimation from 'react-animate-on-scroll';

import gamefi_img1 from '../../Images/gamefi_img1.png';
import gamefi_img2 from '../../Images/gamefi_img2.png';
import gamefi_img3 from '../../Images/gamefi_img3.png';
import diagram1 from '../../Images/diagram1.png';
import diagram2 from '../../Images/diagram2.png';
import diagram3 from '../../Images/diagram3.png';
import diagram_m1 from '../../Images/diagram_m1.png';
import diagram_m2 from '../../Images/diagram_m2.png';
import diagram_m3 from '../../Images/diagram_m3.png';
import nft_chack_icon from '../../Images/nft_chack_icon.png';
import nft_img from '../../Images/nft_img.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 120px;
  padding-bottom: 280px;
  background-color: #fafafa;
`
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 1170px;
  position: relative;
  z-index: 10;
  justify-content: center;
  align-items: center;
  @media (max-width: 1210px) {
    width: 100%;
    padding: 0 20px;
  };
`
const ContentsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
`
const Item = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 370px;
  padding: 0 20px;
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;

    & > img {
      height: 140px;
      object-fit: contain;
    }
    & > p:nth-child(2) {
      margin-top: 40px;
      font-size: 17px;
      font-weight: 600;
      text-align: center;
      line-height: 140%;
    }
    & > p:nth-child(3) {
      margin-top: 20px;
      font-size: 15px;
      font-weight: 200;
      text-align: center;
      line-height: 180%;
    }
  }
`
const DiagramContainer = styled.div`
  width: 970px;
  @media (max-width: 1050px) {
    width: 100%;
  };
`
const NftContainer = styled.div`
  margin-top: 180px;
  width: 100%;
  background-color: #080B31;
  border-radius: 20px;
  padding: 50px;
  padding-bottom: 50px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  & > div:nth-child(1) {
    margin-top: 20px;
    & > p {
      color: white;
      font-size: 28px;
      line-height: 160%;
    }
    & > p:nth-child(1) {
      font-weight: 200;
    }
    & > p:nth-child(2) {
      font-weight: 600;
    }
    & > p:nth-child(3) {
      margin-top: 10px;
      font-size: 15px;
      font-weight: 200;
      max-width: 460px;
      line-height: 160%;
    }
    & > div {
      margin-top: 30px;
      & > div {
        & + div {
          margin-top: 10px;
        }
        display: flex;  
        align-items: center;
        flex-direction: row;
        & > img {
          width: 26px;
        }
        & > p {
          line-height: 120%;
          margin-left: 15px;
          font-size: 15px;
          color: white;
        }
      }
    }
  }
  & > div:nth-child(2) {
    margin-left: auto;
    & > img {
      width: 500px;
      @media (max-width: 1170px) {
        margin-top: 40px;
      };
      @media (max-width: 540px) {
        width: 100%;
      };
    }
  }
`

const GameFiContainer2 = ({ language }) => {
  return (
    <Container>
      <SubContainer>
        <SubTitle
          style={{ marginTop: 40 }}
          title={
            language === "Korean" ?
              '플레이어 중심의 Game-Fi 프로토콜'
              :
              'Player oriented Game-Fi Protocol'
          }
        />
        <ContentsContainer>
          <Item>
            <ScrollAnimation animateIn='fadeInUp'>
              <img alt="" src={gamefi_img1} />
              {
                language === "Korean" ?
                  <>
                    <p>게임화폐 유동성 조절</p>
                    <p>플레이어가 게임화폐를 코인으로 환전할 수 있도록 개발자는 거버넌스 토큰 GRX를 담보로 예치하여 게임화폐의 유동성을 조절할 수 있습니다.</p>
                  </>
                  :
                  <>
                    <p>Game Currency Liquidity Control</p>
                    <p>Developers can control the liquidity of the game currency by depositing governance token GRX as a collateral so that players can exchange game currency for coin.</p>
                  </>
              }
            </ScrollAnimation>
          </Item>
          <Item>
            <ScrollAnimation animateIn='fadeInUp' duration="1.25">
              <img alt="" src={gamefi_img2} />
              {
                language === "Korean" ?
                  <>
                    <p>플레이어 EX-POWER</p>
                    <p>플레이어는 게임화폐를 유틸리티 토큰 VRX로 환전할 수 있습니다. 엑스파워는 실시간 담보풀 변화에 따라 게임화폐를 VRX로 환전할 수 있는 총액을 의미합니다.</p>
                  </>
                  :
                  <>
                    <p>Player EX-POWER</p>
                    <p>Players can exchange their game currency for the utility token VRX. EX Power means the total amount of game currency that can be exchanged for VRX according to the real-time change of collateral pool.</p>
                  </>
              }
            </ScrollAnimation>
          </Item>
          <Item>
            <ScrollAnimation animateIn='fadeInUp' duration="1.5">
              <img alt="" src={gamefi_img3} />
              {
                language === "Korean" ?
                  <>
                    <p>가상자산 시장의 유동성 공급</p>
                    <p>전 세계 10,000여 종이 넘는 코인이 존재합니다. 거래소에 상장된 코인을 보유한 기업(재단)은 게임 생태계에 유동성을 공급하고 홀더를 확보할 수 있습니다.</p>
                  </>
                  :
                  <>
                    <p>Liquidity Supply for the Virtual Asset Market</p>
                    <p>There are over 10,000 coins around the world. Companies (foundations) which own coins listed on the exchange can provide liquidity for the game ecosystem and secure holders.</p>
                  </>
              }
            </ScrollAnimation>
          </Item>
        </ContentsContainer>
        <DiagramContainer>
          <SubTitle
            style={{ marginTop: 180 }}
            title={'Game-Fi Mechanism'}
            text={
              language === "Korean" ?
                '게임사는 신규유저 등록 수에 따라 GRX를 채굴할 수 있으며 유저를 확보한 다음 담보풀에 GRX를 스테이킹하여 게임화폐에 유동성을 공급할 수 있습니다. GREX 생태계에서 유저 수와 게임화폐 총량은 게임의 활성도를 의미하며 이는 게임사의 경제적 가치로 이어집니다.'
                :
                'Developers can mine GRX according to new user registrations. They can secure users and then deposit GRX in a collateral pool to supply liquidity to game currency. In the GREX ecosystem, the number of users and the total amount of game currency means the activity of the game, which leads to the economic value of the game company.'
            }
          />
          <Diagram
            style={{ marginTop: 80 }}
            teblet={870}
            tebletMaxWidth={970}
            img1={diagram2}
            img2={diagram1}
            img3={diagram3}
            tImg1={diagram_m2}
            tImg2={diagram_m1}
            tImg3={diagram_m3}
          />
        </DiagramContainer>
        <NftContainer>
          <div>
            {
              language === "Korean" ?
              <>
                <p>실효성 높은</p>
                <p>채굴형 NFT, GREXUP!</p>
                <p>우리는 게임화폐의 VRX 환율을 높일 수 있는 치트키 NFT를 발행 할 계획입니다. 개발자는 G-Wallet에서 아이템 NFT를 팔거나 게 임화폐 채굴형 NFT를 발행하여 플레이어 충성도를 높일 수 있습 니다.</p>
              </>
              :
              <>
                <p>Highly Effective</p>
                <p>Mining NFT, GREXUP!</p>
                <p>We will issue a cheat key NFT that can increase the VRX exchange rate of game currency. Developers can increase player loyalty by selling item NFTs on G-Wallet or issuing game currency mining NFTs.</p>
              </>
            }
            <div>
              <ScrollAnimation animateIn='fadeInUp' >
                <img alt="" src={nft_chack_icon} />
                {
                  language === "Korean" ?
                  <p>Game-Fi NFT 민팅 및 연동</p>
                  :
                  <p>Game-Fi NFT Minting and Interworking</p>
                }
              </ScrollAnimation>
              <ScrollAnimation animateIn='fadeInUp' duration="1.25">
                <img alt="" src={nft_chack_icon} />
                {
                  language === "Korean" ?
                  <p>게임화폐 채굴 및 VRX 환율 UP</p>
                  :
                  <p>Game currency Mining and VRX Exchange Rate Up</p>
                }
              </ScrollAnimation>
              <ScrollAnimation animateIn='fadeInUp' duration="1.5">
                <img alt="" src={nft_chack_icon} />
                {
                  language === "Korean" ?
                  <p>홀더 회원등급 UP</p>
                  :
                  <p>Holder member rating UP</p>
                }
              </ScrollAnimation>
              <ScrollAnimation animateIn='fadeInUp' duration="1.75">
                <img alt="" src={nft_chack_icon} />
                {
                  language === "Korean" ?
                  <p>한정수량으로 NFT 가치상승</p>
                  :
                  <p>Limited quantity NFT value increase</p>
                }
              </ScrollAnimation>
            </div>
          </div>
          <div>
            <img alt="" src={nft_img} />
          </div>
        </NftContainer>
      </SubContainer>
    </Container>
  )
}

export default GameFiContainer2;